import { onCleanup } from "solid-js";
import * as rive from "@rive-app/canvas";

declare namespace Rive {
  type Props = {
    src: string;
    class?: string;
  };
}

function Rive({ src, class: className }: D<Rive.Props>) {
  return (
    <canvas
      ref={(canvas) => {
        const r = new rive.Rive({
          src,
          canvas,
          autoplay: true,
          onLoad() {
            r.resizeDrawingSurfaceToCanvas();
          },
        });

        onCleanup(() => {
          r.cleanup();
        });
      }}
      class={className}
    />
  );
}

export default Rive;
